import { LOAD_MODEL, RESET_MODEL } from "../constans";

export const loadModelAction = (result) => ({
  type: LOAD_MODEL,
  payload: result,
});

export const resetModel = () => ({
  type: RESET_MODEL,
});
